import { View, html } from 'rune-ts';
import format from 'date-fns/format/index.js';
import ko from 'date-fns/locale/ko/index.js';
import enUS from 'date-fns/locale/en-US/index.js';
import ja from 'date-fns/locale/ja/index.js';
import klass from './SalesPeriodSectionView.module.scss';
import { classes } from '@services/MarppleShop/shared/util';
import { font } from '@services/MarppleShop/shared/typography';
import { ELang } from '@services/MarppleShop/shared/enum/ELang.ts';

type TProps = {
  salePeriod: {
    startDate: string | null;
    endDate: string | null;
  };
};

export class SalesPeriodSectionView extends View<TProps> {
  protected override template({ salePeriod }: TProps) {
    const locale = ET.lang === ELang.Kr ? ko : ET.lang === ELang.Jp ? ja : enUS;

    if (salePeriod.startDate && salePeriod.endDate) {
      // 판매 시작일시 O && 판매 종료일시 O
      return html`<div class="${klass.product_summary}">
        <span class="${classes(klass.section_title, font('14_bold', '12_bold'))}">
          ${ET('delivery_lead_time::product_detail::sales_period_title')}
        </span>

        <div class="${classes(klass.product_summary_detail, font('14_medium', '12_medium'))}">
          <span>${format(new Date(salePeriod.startDate), 'yyyy-MM-dd(EEE) HH:mm', { locale })}</span>

          <span>-</span>

          <span>${format(new Date(salePeriod.endDate), 'yyyy-MM-dd(EEE) HH:mm', { locale })}</span>
        </div>
      </div>`;
    } else if (salePeriod.startDate) {
      // 판매 시작일시 O && 판매 종료일시 X
      return html`<div class="${klass.product_summary}">
        <span class="${classes(klass.section_title, font('14_bold', '12_bold'))}">
          ${ET('delivery_lead_time::product_detail::sales_period_title')}</span
        >

        <div class="${classes(klass.product_summary_detail, font('14_medium', '12_medium'))}">
          <span>${format(new Date(salePeriod.startDate), 'yyyy-MM-dd(EEE) HH:mm', { locale })}</span>

          <span> ${ET('delivery_lead_time::product_detail::sales_period_from')} </span>
        </div>
      </div>`;
    } else if (salePeriod.endDate) {
      // 판매 시작일시 X && 판매 종료일시 O
      return html`<div class="${klass.product_summary}">
        <span class="${classes(klass.section_title, font('14_bold', '12_bold'))}">
          ${ET('delivery_lead_time::product_detail::sales_period_title')}</span
        >

        <div class="${classes(klass.product_summary_detail, font('14_medium', '12_medium'))}">
          <span>${format(new Date(salePeriod.endDate), 'yyyy-MM-dd(EEE) HH:mm', { locale })}</span>

          <span>${ET('delivery_lead_time::product_detail::sales_period_end')}</span>
        </div>
      </div>`;
    } else {
      return html`<div style="display: none"></div>`;
    }
  }
}
